<!-- DlgSelectGroupComponent Template -->
<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-50 no-scrollbar">
  <div class="bg-white shadow-xl rounded-xl p-6 max-w-md w-full relative">

    <!-- Header: Title + Close X -->
    <div class="flex flex-row justify-between items-center mb-4">
      <h1 class="font-bold text-xl text-blueGray-800">Select Community</h1>
      <button type="button" (click)="onCancel()"
        class="text-gray-400 hover:text-gray-600 focus:outline-none border-none bg-transparent cursor-pointer">
        <i class="fas fa-xmark text-xl"></i>
      </button>
    </div>

    <!-- Description -->
    <p class="text-sm text-blueGray-500 mb-6">
      Please select which of your communities you want to create the event for.
    </p>

    <!-- Custom Rich Dropdown -->
    <div class="relative mb-6">
      <label class="block text-xs font-bold uppercase text-blueGray-500 mb-2">Community</label>

      <!-- Dropdown Trigger Button -->
      <button type="button" (click)="toggleDropdown()"
        class="w-full flex items-center justify-between bg-white border border-blueGray-300 rounded-lg px-3 py-2.5 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-500 cursor-pointer">
        <div class="flex items-center gap-3">
          @if (selectedGroup) {
          @if (selectedGroup.imageUrl) {
          <img [src]="selectedGroup.imageUrl" class="h-8 w-8 rounded-full object-cover border border-blueGray-200" />
          } @else {
          <div
            class="h-8 w-8 rounded-full bg-primary-100 text-primary-500 font-bold flex items-center justify-center text-xs">
            {{selectedGroup.name | initials}}
          </div>
          }
          <span class="text-sm font-semibold text-blueGray-700">{{ selectedGroup.name }}</span>
          } @else {
          <span class="text-sm text-blueGray-400">Select a group...</span>
          }
        </div>
        <i class="fas fa-chevron-down text-blueGray-400 text-xs ml-2"></i>
      </button>

      <!-- Dropdown Menu Options -->
      @if (isOpen) {
      <div
        class="absolute z-50 left-0 right-0 mt-1 bg-white border border-blueGray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto no-scrollbar">
        @for (group of groups; track group.id) {
        <div (click)="selectGroup(group)"
          class="flex items-center gap-3 px-3 py-2.5 hover:bg-primary-50 cursor-pointer transition-colors border-b border-blueGray-50 last:border-b-0">
          @if (group.imageUrl) {
          <img [src]="group.imageUrl" class="h-8 w-8 rounded-full object-cover border border-blueGray-200" />
          } @else {
          <div
            class="h-8 w-8 rounded-full bg-primary-100 text-primary-500 font-bold flex items-center justify-center text-xs">
            {{group.name | initials}}
          </div>
          }
          <div class="flex-1 min-w-0">
            <p class="text-sm font-semibold text-blueGray-700 truncate">{{ group.name }}</p>
            <p class="text-[10px] text-blueGray-400 truncate">{{ group.address?.city || 'Local Region' }}</p>
          </div>
          @if (selectedGroup?.id === group.id) {
          <i class="fas fa-check text-primary-500 text-xs"></i>
          }
        </div>
        }
      </div>
      }
    </div>

    <!-- Footer Action Buttons -->
    <div class="flex flex-row gap-3 justify-end">
      <button type="button" (click)="onCancel()"
        class="text-blueGray-500 hover:text-blueGray-700 font-semibold px-4 py-2 focus:outline-none border-none bg-transparent cursor-pointer text-sm">
        Cancel
      </button>
      <button type="button" (click)="submit()" [disabled]="!selectedGroup"
        class="bg-primary-500 hover:bg-primary-600 disabled:bg-primary-200 text-white rounded-lg font-semibold px-5 py-2 focus:outline-none border-none cursor-pointer text-sm transition-colors shadow">
        Proceed
      </button>
    </div>

  </div>
</div>